import React from 'react';
import ResendPassword from 'src/components/UI/resendPassword/ResendPassword';

const ResendPasswordPage = () => <ResendPassword />;

export default ResendPasswordPage;
